export const periodicityOptions = [
    {key: 1, value: 'Mensual'},
    {key: 3, value: 'Trimestral'},
    {key: 6, value: 'Semestral'},
    {key: 12, value: 'Anual'}
];